// Module
var code = "<p>{{vm.msg}}</p>";
// Exports
module.exports = code;